@if (hasEntitlement) {
  <div>
    @if (showStatusBox) {
      <div class='status-message-container'>
        @if (successBanner) {
          <mat-card appearance="outlined" class="status-message-banner success-status">
            <div class="status-text">
              <span class="material-symbols-outlined">info</span> {{statusText}}
            </div>
          </mat-card>
        }
        @if (!successBanner) {
          <mat-card appearance="outlined" class="status-message-banner fail-status">
            <div class="status-text">
              <span class="material-symbols-outlined">info</span> {{statusText}}
            </div>
          </mat-card>
        }
      </div>
    }
    <div class="card-container">
      @if (displayCardOne) {
        <mat-card appearance="outlined" class="card-item">
          <div class="flex-top">
            <span class="heading-container">
              <button mat-mini-fab disabled class="mini-fab-button">1</button>
              <mat-card-title>{{cardOneLabel}}</mat-card-title>
            </span>
            <mat-card-subtitle>{{cardOneSubtitle}}</mat-card-subtitle>
            @if (displayCardOneAlert) {
              <mat-card-subtitle class="tiny-note">{{cardOneAlert}}</mat-card-subtitle>
            }
          </div>
          <div class="flex-bottom">
            @if (displayCardOneButtonOne) {
              <button type="submit" mat-raised-button (click)="downloadBrokerTemplate()">{{cardOneButtonLabel}}</button>
            }
            @if (displayCardOneButtonTwo) {
              <button type="submit" mat-raised-button (click)="downloadBrokerTemplate2()">{{cardOneButtonLabelTwo}}</button>
            }
          </div>
        </mat-card>
      }
      @if (displayCardTwo) {
        <mat-card appearance="outlined" class="card-item">
          <div class="flex-top">
            <span class="heading-container">
              <button mat-mini-fab disabled class="mini-fab-button">2</button>
              <mat-card-title>{{cardTwoLabel}}</mat-card-title>
            </span>
            <mat-card-subtitle>{{cardTwoSubtitle}}</mat-card-subtitle>
          </div>
        </mat-card>
      }
      @if (displayCardThree) {
        <mat-card appearance="outlined" class="card-item">
          <div class="flex-top">
            <span class="heading-container">
              <button mat-mini-fab disabled class="mini-fab-button">3</button>
              <mat-card-title>{{cardThreeLabel}}</mat-card-title>
            </span>
            <mat-card-subtitle>{{cardThreeSubtitle}}</mat-card-subtitle>
          </div>
          <div class="flex-bottom">
            @if (!showSpinner) {
              <label for="file" class="input-as-button-label">{{cardThreeButtonLabel}}</label>
              <input type="file" accept=".csv, .xlsx, .xls" id="file" (change)="handleFileInput($event.target.files)">
            }
            @if (showSpinner) {
              <mat-spinner [diameter]="40"></mat-spinner>
            }
          </div>
        </mat-card>
      }
      @if (displayCardFour) {
        <mat-card appearance="outlined" class="card-item">
          <div class="flex-top">
            <span class="heading-container">
              <button mat-mini-fab disabled class="mini-fab-button">4</button>
              <mat-card-title>{{cardFourLabel}}</mat-card-title>
            </span>
            <mat-card-subtitle>{{cardFourSubtitle}}</mat-card-subtitle>
          </div>
        </mat-card>
      }
      @if (displayCardFive) {
        <mat-card appearance="outlined" class="card-item">
          <div class="flex-top">
            <span class="heading-container">
              <button mat-mini-fab disabled class="mini-fab-button">5</button>
              <mat-card-title>{{cardFiveLabel}}</mat-card-title>
            </span>
            <mat-card-subtitle>{{cardFiveSubtitle}}</mat-card-subtitle>
          </div>
        </mat-card>
      }
    </div>
    <div class="file-display-table-container">
      <mat-table mat-table class="mat-elevation-z8" matSort
        [dataSource]="dataSource">
        <ng-container matColumnDef="filename">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="label-and-form-field-container">
              <span class="header-span">File Name</span>
              <mat-form-field class="filter">
                <mat-label>Search</mat-label>
                <input matInput [formControl]="fileNameFilter" (keydown.space)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()">
                </mat-form-field>
              </span>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">{{file.filename}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="dateTime">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <span class="label-and-form-field-container">
                <span class="header-span">Upload Date</span>
                <mat-form-field class="filter short-filter">
                  <mat-label>Search</mat-label>
                  <input matInput [formControl]="dateFilter" (keydown.space)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                  </mat-form-field>
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let file">{{file.dateTime | date:'MM/dd/yyyy HH:mm:ss'}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="message">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="label-and-form-field-container">
                  <span class="header-span">Upload Status</span>
                  <mat-form-field class="filter">
                    <mat-label>Search</mat-label>
                    <input matInput [formControl]="statusFilter" (keydown.space)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()">
                    </mat-form-field>
                  </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let file" class="file-status-container file-message">
                  {{getTruncatedFileMessage(file.message)}}
                  @if (showTooltipOnTruncatedMessage) {
                    <div matTooltip="{{file.message}}">
                      <span class="material-symbols-outlined">info</span>
                    </div>
                  }
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="fileId">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                  <span class="label-and-form-field-container">
                    <span class="header-span">Tracking ID</span>
                    <mat-form-field class="filter short-filter">
                      <mat-label>Search</mat-label>
                      <input matInput [formControl]="fileIdFilter" (keydown.space)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()">
                      </mat-form-field>
                    </span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let file" class="file-status-container">
                    {{file.fileId}}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="logs">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span class="label-and-form-field-container">
                      <span class="header-span">Logs</span>
                      <mat-form-field class="filter">
                        <mat-label>Search</mat-label>
                        <input matInput [formControl]="statusFilter" (keydown.space)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()">
                        </mat-form-field>
                      </span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let file" class="file-status-container">
                      <div>
                        @if (uploadSuccess(file.message)) {
                          <span>Submission Log</span>
                        }
                        @if (!uploadSuccess(file.message)) {
                          <span>Error Log</span>
                        }
                      </div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="icon">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let file" class="file-status-container">
                      <div>
                        @if (showSubmissionLogIcon) {
                          <span class="material-symbols-outlined" (click)="navigateToSubmittedAppsPage(file.fileId)">attachment
                          </span>
                        }
                        @if (!showSubmissionLogIcon) {
                          <span class="material-symbols-outlined" (click)="downloadErrorLogByFileId(file.fileId)">download</span>
                        }
                      </div>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                <div class="paginator-container">
                  <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]">
                  </mat-paginator>
                </div>
              </div>
            </div>
          }

          @if (!hasEntitlement) {
            <div>
              {{ noEntitlementsMessage || 'Your currently selected agency does not have access to view Mass Upload. Try a
              different agency if available.'}}
            </div>
          }
